import { StopCause } from "../../../Types/StopCause";

export type StopCodingFilterType = 'all' | 'workcenter' | 'group' | 'machine';

export class StopCoding{
    allStopCauses: StopCause[] = [];
    drillDownFiteredStopCauses: StopCause[] = [];
    currentTimeRangeStopsCauses : StopCause[] = [];
    previousTimeeRangeStopCauses : StopCause[] = [];
    stopCodingFilterValue: string = '';
    stopCodingFilterDisplayValue: string = '';
    stopCodingFilterType: StopCodingFilterType = 'all';
    cascadeReasonVisibility: Record<string, boolean> = {};
    selectedCascadeReason: string = '';
    focusedCascadeReason: string = '';
    chartMode: 'count' | 'duration' = 'count';
    startDate: Date = new Date();
    endDate: Date = new Date();
}